"use client";

import type { AppRouter } from "@chaski/bff";
import { createClientTrpcClient, trpc } from "@portal/lib/trpc/client";
import type { QueryClient } from "@tanstack/react-query";
import type { TRPCClient } from "@trpc/client";
import { useEffect, useRef, useState } from "react";
import { useCustomerStore } from "../Customer/CustomerContext";

export function TrpcProvider({
  queryClient,
  children,
}: {
  queryClient: QueryClient;
  children: React.ReactNode;
}) {
  const activeHub = useCustomerStore((state) => state.activeHub);
  const isLoadingActiveHub = useCustomerStore(
    (state) => state.isLoadingActiveHub,
  );

  const dynamicHeaders = useRef<Record<string, string>>({});

  useEffect(() => {
    const candidateHeaders = {
      "x-active-hub": activeHub?.xActiveHub,
    };
    for (const [key, value] of Object.entries(candidateHeaders)) {
      if (value) {
        dynamicHeaders.current[key] = value;
      } else {
        delete dynamicHeaders.current[key];
      }
    }
  }, [isLoadingActiveHub, activeHub]);

  /**
   * Keeping this is state ensures that this runs _only_ on the clientside, and that we create a new trpc client
   * for every user request to the server
   */
  const [trpcClient] = useState<TRPCClient<AppRouter>>(() =>
    createClientTrpcClient({ getHeaders: () => dynamicHeaders.current }),
  );
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
}
